import React from 'react';

import miniGazelle from '../miniGazelle/miniGazelle';

export default function(i, currentSlide, onDotClick) {
    const print = i + 1;

    return (
        <button onMouseDown={() => {
            if(onDotClick){
                onDotClick?.()
            }
        }}>
            {currentSlide === i ? miniGazelle.label('currentlyOnScreen', true) : null}{' '}
            {`${miniGazelle.label('slide', true)}: ${print}`}
        </button>
    );
}
